import { render } from "./Technology-consulting.vue?vue&type=template&id=2442bd8b&scoped=true"
import script from "./Technology-consulting.vue?vue&type=script&lang=js"
export * from "./Technology-consulting.vue?vue&type=script&lang=js"

import "./Technology-consulting.vue?vue&type=style&index=0&id=2442bd8b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2442bd8b"]])

export default __exports__